import { publicInstance } from '@/api/axiosInstance';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import actions from '@/state/ducks/auth/actions';
import { saveUserDataInLocalStorage } from '@/utils/user';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function CodeVerificationPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    codeVerify();
  }, []);

  const codeVerify = async () => {
    const originUrl = document.referrer;

    try {
      dispatch(actions.handleLoginRequest());

      const referrer = window.location.origin + window.location.pathname;

      const search = window.location.search;
      const searchParams = new URLSearchParams(search);

      const { data: resData } = await publicInstance.post(
        '/authorization/auth/code/verify',
        { code: searchParams.get('code') },
        {
          headers: {
            clientId: String(process.env.REACT_APP_CLIENT_ID),
            clientSecret: String(process.env.REACT_APP_CLIENT_PASSWORD),
            'X-Custom-Referrer': referrer,
          },
        },
      );

      if (resData) {
        saveUserDataInLocalStorage(resData.accessToken, resData.refreshToken);

        dispatch(actions.handleLoginSuccess(resData.accessToken));

        window.location.href = searchParams.get('redirectUrl') || '/app/home';
      } else {
        if (originUrl) {
          const search = new URLSearchParams({
            error: 'Código de autenticação inválido',
          });
          window.open(`${originUrl}?${search}`, '_self');
        }
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (originUrl) {
        const search = new URLSearchParams({
          error: error.message || 'Não foi autenticar o usuário',
        });
        window.open(`${originUrl}?${search}`, '_self');
      }
    }
  };

  return <ModalLoadingOverlay messages={['Validando acesso...']} />;
}
